import { Mapper } from "../../../../../base/utils/mapper";
import { ConsultancyModel } from "../../../../../domain/models/configuration/company/consultancy.model";
import { ConsultancyEntity } from "../../entities/company/consultancy.entity";



export class ConsultancyImplementationRepositoryMapper extends Mapper<ConsultancyEntity, ConsultancyModel> {
    mapFrom(param: ConsultancyEntity): ConsultancyModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ConsultancyModel): ConsultancyEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}